export enum DashboardMenuOption {
  MANAGE_ISSUES = 'manage-issues',
  ADD_FOLLOW_UP = 'add-follow-up',
  CONDUCT_HEALTHCHECK = 'conduct-healthcheck',
  CHANGE_STAFFING_COORDINATOR = 'change-staffing-coordinator',
  CHANGE_ZONE = 'change-zone',
}

interface MenuOptionItem {
  key: string;
  label: string;
  onClick?: () => void;
  expandable?: boolean;
  subOptions?: MenuOptionItem[];
}

export interface DashboardCallbacks {
  menuOptions: MenuOptionItem[];
  handleFollowUpRemove: (itemId: string | number, followUpId: string | number) => void;
  handleFollowUpUpdate: (
    itemId: string | number,
    followUpId: string | number,
    data: { description: string; date: string },
  ) => void;
}
